import http from '@/api/http'

export default {
  /**
   * サーバからアプリ課金データ取得
   */
  fetchAppPayment(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/app_payment/', params)
        .then(res => {
          resolve(res.data)
        })
        .catch(reject)
    })
  },

  /**
   * アプリ課金の成否判定結果を通知
   */
  reportAppPaymentValidator(product): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/subscription/', product)
        .then(res => {
          resolve(res.data)
        })
        .catch(reject)
    })
  }
}
